import {OrderSheetPageSet} from '@web/core/constants'
import getApi, {createWrapper, getBaseUrl} from '@web/helpers/api'

import {FetchIntegratedDiscountRequest, FetchIntegratedDiscountResponse} from './interfaces'

const DiscountUrlInfo = {
    [OrderSheetPageSet.SELLER]: {
        integratedDiscount: '/orderSheet/seller/integratedDiscount',
    },
} as const

async function getIntegratedDiscount({pageSet, params}: FetchIntegratedDiscountRequest) {
    const url = DiscountUrlInfo[pageSet].integratedDiscount
    const baseUrl = getBaseUrl(pageSet)
    const api = getApi(baseUrl)
    return createWrapper<FetchIntegratedDiscountResponse>(api.post(url, params))
}

export default {getIntegratedDiscount}
